<template>
  <div id="tab-ams" class="ams-info">
    <!--AMS按钮：数据抄录/同步HBL信息/代码检索...-->
    <div v-if="showCodeSearch" class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            style="padding-left: 5px;"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ this.getItemTitle(command1) }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Copy Last Time" :title="$t('SeaExport.CopyLast')">{{ this.getItemTitle('Copy Last Time') }}</el-dropdown-item>
              <el-dropdown-item command="Copy By File NO" :title="$t('SeaExport.WaybillNumberCopy')">{{ this.getItemTitle('Copy By File NO') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-radio-group v-if="isJs" v-model="saveAs" style="margin-left: 20px;">
            <el-radio label="1">{{ $t('SeaExport.CargoWare') }}</el-radio>
            <el-radio label="2">{{ $t('SeaExport.Other') }}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!--收发通信息/货物信息/运输信息/其他信息-->
    <div style="width: fit-content">
      <div style="display: flex">
        <!--收发通信息-->
        <address-format-form
          v-if="!showISF"
          :job="job"
          :show-second-notify-party="showSecondNotifyParty"
          :readonly="readonly"
          :local-data="localData"
          :address-form="form.afrAddress[0] || {}"
          :tab-name="tabName"
          :is-js="isJs"
          :js-send-hide="jsSendHide"
          @showSenderAndReceiverDialog="showSenderAndReceiverDialog"
          @selectionItemHandlerByType="p=>{pm.selectionItemHandlerByType(p)}"
        />
        <!--货物信息-->
        <div v-show="!showISF" class="section form-column">
          <el-form :disabled="readonly" label-width="112px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.CargoInformation')">{{ getItemTitle('Cargo Information') }}</span>
            <el-form-item :title="$t('SeaExport.BillOfLadingQuantity')" :label="getItemTitle('Quantity')" :class="isDifferent('quantity')">
              <auto-number-input
                v-model="form.quantity"
                :precision="0"
                :min="0"
                no="2"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Packing')" :label="getItemTitle('Unit Type')" :class="isDifferent('packing')">
              <span slot="label">
                <el-tooltip
                  :content="$t('CargoMsg.Cargo_AmsUnitTypeTip')"
                  placement="right-end"
                >
                  <i
                    class="el-icon-question"
                    style="cursor: pointer;color: #1F75D5;"
                  />
                </el-tooltip>
                {{ getItemTitle('Unit Type') }}
              </span>
              <cargo-packing-select
                :default-value="form.packing"
                style="width:100%;"
                no="3"
                @change="changeUnitType"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.GrossWeight')" :label="getItemTitle('Gross Weight')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.weight"
                  :class="isDifferent('weight')"
                  :precision="jsSendHide?0:3"
                  :controls="false"
                  style="flex: 1"
                  no="4"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Cubage')" :label="getItemTitle('Volume')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.cubage"
                  :class="isDifferent('cubage')"
                  :precision="jsSendHide?0:3"
                  :controls="false"
                  style="flex: 1"
                  no="5"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item v-if="jsSendHide && (isAms || isAci)" :label="getItemTitle('Cargo Type')">
              <el-select v-model="form.goodsType" no="50">
                <el-option :label="getItemTitle('General Cargo')" :value="0" />
                <el-option :label="getItemTitle('Dangerous Cargo')" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="jsSendHide && isAms && isDangerousCargo" :label="getItemTitle('Hazardous code')">
              <el-input v-model="form.hazardousCode" no="51" />
            </el-form-item>
            <el-form-item v-if="jsSendHide && isAms && isDangerousCargo" :label="getItemTitle('Flashpoint')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.flashPointTemp"
                  :precision="jsSendHide?0:3"
                  :controls="false"
                  style="flex: 1"
                  no="52"
                />
                <span>℃</span>
              </div>
            </el-form-item>
            <el-form-item v-show="jsSendHide && isAci && isDangerousCargo" :label="getItemTitle('Hazardous code')">
              <el-input v-model="form.undgCode" no="55" />
            </el-form-item>
            <el-form-item v-if="!jsSendHide" :title="$t('SeaExport.FLCLType')" :label="getItemTitle('Consignment Type')" :class="isDifferent('containerLoadType')">
              <el-select
                v-model="form.containerLoadType"
                :placeholder="$t('SeaExport.PleaseChoose')"
                no="6"
              >
                <el-option
                  v-for="(item,index) in consignmentTypes"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="tabName === 'eManifest'" :title="$t('SeaExport.CustomerType')" :label="getItemTitle('Customer Type')">
              <el-select
                v-model="form.customerType"
                :placeholder="$t('SeaExport.PleaseChoose')"
                no="7"
              >
                <el-option
                  v-for="(item,index) in customerTypes"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="tabName === 'eManifest'" :label="getItemTitle('HTS CODE')" :title="$t('SeaExport.HTSCode')">
              <el-input v-model="form.htsCode" no="8" />
            </el-form-item>
            <el-form-item label-width="0" :title="$t('SeaExport.EnglishCommodityName')"><span>{{ getItemTitle('Commodity Decription') }}</span></el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                :class="isDifferent('cargoEnglishName')"
                :disabled="!isEdit"
                :text-chars="0"
                wrap-symbol="r"
                auto-uppercase
                auto-half-word
                style="height: 110px"
                :warning-count="-1"
                no="9"
              />
            </el-form-item>
            <el-form-item label-width="0" :title="$t('SeaExport.ShippingMark')"><span>{{ getItemTitle('Marks') }}</span></el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <cargo-rich-textarea
                v-model="form.mark"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                :disabled="!isEdit"
                no="10"
              />
            </el-form-item>
            <el-form-item label-width="0" :title="$t('SeaExport.Remarks')"><span>{{ getItemTitle('Remark') }}</span></el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <el-input
                v-model="form.remarks"
                :disabled="!isEdit"
                type="textarea"
                :rows="5"
                no="11"
              />
            </el-form-item>
          </el-form>
        </div>
        <!--运输信息-->
        <div v-show="!showISF" class="section form-column">
          <el-form :disabled="readonly" label-width="120px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportationInformation')">{{ getItemTitle('Shipping Information') }}</span>
            <!-- CARGO-32892 企泰AMS报文调整：【企泰反恐舱单】报文需要对 【反恐舱单-AMS NO】字符数量限制-->
            <el-form-item v-if="(isTradetech || isEFreight) && tabName === 'ams'" id="hblNbr2" :label="amsTitle" :title="amsTitleCn" :class="isDifferent('hblNbr2') ">
              <span slot="label">
                <el-tooltip :content="isEFreight ? $t('CargoMsg.Cargo_AmsNoEFreightTooltip') : $t('CargoMsg.Cargo_AmsNoTooltip')" placement="right-end">
                  <i class="el-icon-warning" style="cursor: pointer;color: #1F75D5;" />
                </el-tooltip>
                {{ amsTitle }}
              </span>
              <cargo-rich-textarea
                v-model="form.hblNbr2"
                :is-trim="true"
                :disabled="readonly"
                style="min-height: 0px;"
                :warning-count="12"
                no="12"
                @change="hblNbr2Change"
              />
            </el-form-item>
            <el-form-item v-else :label="amsTitle" :title="amsTitleCn" :class="isDifferent('hblNbr2')">
              <el-input v-model="form.hblNbr2" no="13" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :label="getItemTitle('MB/L NO')" :title="$t('SeaExport.MBLNumber')" :class="isDifferent('mbl')">
              <el-input v-model="form.mbl" no="14" />
            </el-form-item>
            <el-form-item v-show="tabName !== 'ams'" :label="getItemTitle('CCN#')" :title="$t('SeaExport.CCNNumber')">
              <el-input v-model="form.mblNbr2" no="15" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Vessel')" :title="$t('SeaExport.ShipName')" :class="isDifferent('vessel')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.static_data_Vessel"
                :cache="false"
                :allow-create="true"
                filterable
                :default-value="form.vessel"
                :static-options="localData.vesselList"
                no="16"
                @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Voyage')" :title="$t('SeaExport.Voyage')" :class="isDifferent('voyageFlight')">
              <cargo-rich-textarea
                v-model="form.voyageFlight"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="tabName === 'ams' ? 5 : 10"
                :is-trim="true"
                style="min-height: unset;"
                no="17"
                @change="changeVoyage"
              />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAms || isAci))" :label="getItemTitle('IMO')" :title="$t('SeaExport.ShipNumber')" :class="isDifferent('vesselIMO')">
              <el-input v-model="form.vesselIMO" no="18" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAms || isAci))" :label="getItemTitle('ETD')" :title="$t('SeaExport.DateOfDeparture')" :class="isDifferent('etd')">
              <el-date-picker v-model="form.etd" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="19" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('ETA')" :title="$t('SeaExport.ArrivalDate')" :class="isDifferent('eta')">
              <el-date-picker v-model="form.eta" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="20" />
            </el-form-item>
            <el-form-item v-show="jsSendHide && isAci" :label="getItemTitle('DestinationCountry')">
              <cargo-advance-select
                no="54"
                :select-type="TYPE_NAMES.basic_data_Country"
                :cache="false"
                filterable
                :default-value="form.cargoDestinationCountry"
                :filter-tag-names="['code','chineseName','name']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.cargoDestinationCountry = p.value}"
              />
            </el-form-item>
            <el-form-item v-show="jsSendHide && isAci" :label="getItemTitle('DestinationCity')">
              <el-input v-model="form.cargoDestinationCity" no="57" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAms || isAci))" :label="getItemTitle('Deliv.Mode')">
              <cargo-advance-select
                no="freightTerm"
                filterable
                :default-value="form.freightTermHBL"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="SystemConstants.AMS_FREIGHT_TERM"
                @parentCallBack="p=>{form.freightTermHBL=p.value;}"
              />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAms || isAci))" :label="getItemTitle('County of Origin')" :title="$t('SeaExport.CountryOfOrigin')">
              <el-input v-model="form.countryOrigin" no="21" />
            </el-form-item>
            <el-form-item v-show="jsSendHide && isAms" :label="getItemTitle('Vessel country flag')">
              <cargo-advance-select
                no="53"
                :select-type="TYPE_NAMES.basic_data_Country"
                :cache="false"
                filterable
                :default-value="form.nationalityCodeofVessel"
                :filter-tag-names="['code','chineseName','name']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.nationalityCodeofVessel = p.value}"
              />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Place of Receipt')" :title="$t('SeaExport.BillLadingPlaceOfDispatch')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                no="22"
                @parentCallBack="p=>{portChange(p, 'dispatchingPlaceCode', 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Place of Loading')" :title="$t('SeaExport.BillLadingPortOfDeparture')" :class="isDifferent('loadingPortCode')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="23"
                @parentCallBack="p=>{portChange(p, 'loadingPortCode', 'loadingPort')}"
              />
              <cargo-advance-select
                v-else
                no="23"
                :static-options="localData.jsPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.loadingPortCode||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'loadingPortCode', 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Discharge')" :title="$t('SeaExport.BillLadingPortOfDischarge')" :class="isDifferent('dischargingPortCode')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="24"
                @parentCallBack="p=>{portChange(p, 'dischargingPortCode', 'dischargingPort')}"
              />
              <cargo-advance-select
                v-else
                no="24"
                :static-options="localData.jsAmsDischargingList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                :default-value="form.dischargingPortCode||''"
                filterable
                clearable
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'dischargingPortCode', 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide)" :label="getItemTitle('Place Of Delivery')" :title="$t('SeaExport.BillLadingPlaceOfDelivery')" :class="isDifferent('destinationPortCode')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="25"
                @parentCallBack="p=>{portChange(p, 'destinationPortCode', 'destinationPort')}"
              />
              <el-input v-model="form.destinationPort" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && isAci)" :title="$t('SeaExport.LastOverseasPort')">
              <span slot="label">
                <el-tooltip
                  :content="$t('CargoMsg.Cargo_LastOverseasPort')"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning"
                    style="cursor: pointer;color: #1F75D5;"
                  />
                </el-tooltip>
                {{ getItemTitle('Last Foreign Port') }}
              </span>
              <cargo-advance-select
                v-if="!jsSendHide"
                filterable
                :select-type="TYPE_NAMES.basic_data_Seaport"
                :default-value="form.lastAbroadProd"
                no="26"
                @parentCallBack="p=>{portChange(p, 'lastAbroadProd', 'lastAbroadProdName')}"
              />
              <cargo-advance-select
                v-else
                no="26"
                :static-options="localData.jsPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                :default-value="form.lastAbroadProd"
                filterable
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'lastAbroadProd', 'lastAbroadProdName')}"
              />
              <el-input v-model="form.lastAbroadProdName" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAci || isAms))" :title="$t('SeaExport.FirstPortOfCall')">
              <span slot="label">
                <el-tooltip
                  :content="$t('CargoMsg.Cargo_FirstPortOfCall')"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning"
                    style="cursor: pointer;color: #1F75D5;"
                  />
                </el-tooltip>
                {{ getItemTitle('First Port of Call') }}
              </span>
              <cargo-advance-select
                filterable
                :select-type="TYPE_NAMES.basic_data_Seaport"
                :default-value="form.firstPortOfCallCode"
                no="27"
                @parentCallBack="p=>{portChange(p, 'firstPortOfCallCode', 'firstPortOfCall')}"
              />
              <el-input v-model="form.firstPortOfCall" />
            </el-form-item>
            <el-form-item v-show="!(jsSendHide && (isAms || isAci))" :label="getItemTitle('ETA First Port Of Call')" :title="$t('SeaExport.ETAFirstPortOfCall')">
              <el-date-picker v-model="form.etaFirstPortOfCall" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="49" />
            </el-form-item>
            <!--Disch Sub Loc-->
            <el-form-item v-show="tabName === 'eManifest'" :label="getItemTitle('Disch Sub Loc')">
              <div style="display: flex">
                <el-input v-model="localData.dishSubLocStr" disabled style="width: 120px;margin-right: 4px" no="28" />
                <el-button type="primary" no="29" @click="selectSubLoc(1)">{{ $t('SeaExport.Select') }}</el-button>
              </div>
            </el-form-item>
            <!--加拿大内陆点/仓库-->
            <el-form-item v-show="tabName === 'eManifest'" :label="getItemTitle('Dest Sub Loc')">
              <div style="display: flex">
                <el-input v-model="localData.subLocationCodeStr" disabled style="width: 120px;margin-right: 4px" no="30" />
                <el-button type="primary" no="31" @click="selectSubLoc(2)">{{ $t('SeaExport.Select') }}</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- ISF -->
        <div v-show="showISF" class="section app-main-content" style="height: 100%">
          <span class="title">ISF</span>
          <div class="tabs-container">
            <el-tabs v-model="activeTabName" type="card">
              <el-tab-pane name="tabBookingISF10" label="ISF10">
                <tab-i-s-f10 ref="tabBookingISF10" :cargo-doc="form" :job="job" :isf-type="10" :is-edit="isEdit" :party-name-list="partyNameList" :local-data="localData" />
              </el-tab-pane>
              <el-tab-pane name="tabBookingISF05" label="ISF05">
                <tab-i-s-f05 ref="tabBookingISF05" :cargo-doc="form" :job="job" :isf-type="5" :is-edit="isEdit" :party-name-list="partyNameList" :local-data="localData" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!--其他信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="left" style="height:100%">
            <span class="title" :title="$t('SeaExport.OtherInformation')">{{ getItemTitle('Other') }}</span>
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="ams2.gridOptions"
                :column-defs="ams2ColumnDefs"
                :row-data="ams2.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{ams2.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button v-show="job.signHBL" type="primary" :title="$t('SeaExport.SynchronizeHBLInformation')" no="32" @click="pm.btnSynchroClickHandler()">{{ getItemTitle('Synchronise HB/L') }}</el-button>
                  <el-button v-show="!job.signHBL" type="primary" :title="$t('SeaExport.Add2')" no="33" @click="pm.onAddCargoDoc()">{{ getItemTitle('Add') }}</el-button>
                  <el-button type="danger" :title="$t('SeaExport.Delete')" no="34" @click="pm.onRemoveCargoDoc()">{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Carrier SCAC')" :title="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :disabled="true" :value="carrierScAc" no="35" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Nvocc SCAC')" :title="$t('SeaExport.NonVesselCarrierSCAC')">
              <el-select v-if="tabName === 'eManifest' || tabName === 'aci'" v-model="form.efNvoccScac" filterable :allow-create="true" no="36">
                <el-option
                  v-for="item in localData.nvoccScacList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select v-else v-model="form.nvoccScac" filterable :allow-create="true" no="37">
                <el-option
                  v-for="item in localData.nvoccScacList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <!-- 加拿大申报账户 -->
            <el-form-item v-if="tabName === 'ams' || tabName === 'aci'" v-show="!jsSendHide" :title="$t('SeaExport.DeclarationAccount')" :label="getItemTitle('Sender Account')">
              <el-select v-if="tabName === 'ams'" v-model="localData.emainAccountStr" no="38">
                <el-option
                  v-for="item in localData.eFreighsAmsList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select v-if="tabName === 'aci'" v-model="localData.emainAccountAciStr" no="39">
                <el-option
                  v-for="item in localData.eFreighsAciList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="jsSendHide && isAms " :label="getItemTitle('paperless_in_bond_participant')">
              <el-select v-model="form.paperlessInBondParticipant" no="54" style="width: 120px;float: right">
                <el-option label="Y" :value="1" />
                <el-option label="N" :value="2" />
              </el-select>
            </el-form-item>
            <div v-show="tabName !== 'isf'">
              <!-- 新增申报类型 -->
              <span :title="$t('SeaExport.DeclarationType')">{{ getItemTitle('Declare Type') }}</span>
              <el-form-item label-width="0" style="margin-top: 5px">
                <el-radio-group v-model="form.frob" no="40">
                  <el-tooltip effect="dark" :content="tabName === 'ams' ? $t('SeaExport.DirectToTheUnitedStates'):$t('SeaExport.DirectToCanada')" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="I" value="I">{{ isAci ? getAciImportInfo('Import') : getItemTitle('Import') }}</el-radio>
                  </el-tooltip>
                  <div v-show="tabName === 'eManifest'">
                    <el-tooltip effect="dark" :content="$t('SeaExport.ToTheInlandWarehouse')" placement="right" style="display: block">
                      <el-radio :disabled="readonly" label="B" value="B">In-Bond</el-radio>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('SeaExport.TransferClearancePullToStates')" placement="right" style="display: block">
                      <el-radio :disabled="readonly" label="S" value="S">In-Transit</el-radio>
                    </el-tooltip>
                  </div>
                  <el-tooltip effect="dark" :content="$t('SeaExport.CargoThroughTheUnitedStates')" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="F" value="F">{{ isAci ? getAciImportInfo('Foreign cargo remaining on-board') : getItemTitle('Foreign cargo remaining on-board') }}</el-radio>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
              <div v-show="tabName !== 'ams'">
                <el-checkbox v-model="secondGenerationCheck" :label="$t('SeaExport.secondGeneration')" no="41" />
                <el-form-item :label="$t('SeaExport.CanadianCustomsRecordNumber')" label-width="110px">
                  <el-input v-model="form.recordNumber" :disabled="readonly" style="width: 60px" no="42" />
                  <el-input v-model="form.efHblNumber" :disabled="readonly" style="margin-left: 5px;width: 125px" no="43" />
                </el-form-item>
              </div>
              <div v-show="tabName === 'eManifest'">
                <el-checkbox v-model="form.coloadInSelfFilingIndicator" :label="getItemTitle('Coload In Self Filing Indicator')" no="56" @change="handleColoadInSelfFilingIndicatorChange" />
                <div v-if="form.coloadInSelfFilingIndicator" class="self-declaration-fields">
                  <el-form-item :label="getItemTitle('Name')">
                    <cargo-advance-select
                      ref="partyName"
                      no="66"
                      :static-options="selfDeclarationList"
                      :cache="false"
                      :default-value="form.partyName"
                      :disabled="!isEdit"
                      filterable
                      clearable
                      :allow-create="true"
                      tag-name="partyName"
                      tag-value="partyName"
                      :placeholder="readonly?'':$t('SeaExport.Required')"
                      @parentCallBack="handleNameSelect"
                    />
                  </el-form-item>

                  <el-form-item :label="getItemTitle('Code')">
                    <el-input v-model="form.partyCode" maxlength="40" :placeholder="readonly?'':$t('SeaExport.Required')" @input="filterInput($event, 'partyCode')" />
                  </el-form-item>

                  <el-form-item :label="getItemTitle('Address')">
                    <el-input v-model="form.partyAddressLine" maxlength="50" :placeholder="readonly?'':$t('SeaExport.Required')" @input="filterInput($event, 'partyAddressLine')" />
                  </el-form-item>
                  <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
                    <div style="display: flex">
                      <el-input v-model="form.partyCountryCode" maxlength="2" :placeholder="readonly?'':$t('SeaExport.Required')" @input="filterAlphabetOnly($event, 'partyCountryCode')" />
                      <span class="center-label" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
                      <el-input v-model="form.partyProvince" maxlength="2" :placeholder="readonly?'':$t('SeaExport.Optional')" @input="filterAlphabetOnly($event, 'partyProvince')" />
                    </div>
                  </el-form-item>
                  <el-form-item :label="getItemTitle('City')" :title="$t('SeaExport.City')">
                    <div style="display: flex">
                      <el-input v-model="form.partyCity" maxlength="25" :placeholder="readonly?'':$t('SeaExport.Optional')" @input="filterAlphabetOnly($event, 'partyCity')" />
                      <span class="center-label" :title="$t('SeaExport.ZIP')">{{ getItemTitle('Zip') }}</span>
                      <el-input v-model="form.partyZipCode" maxlength="10" :placeholder="readonly?'':$t('SeaExport.Optional')" @input="filterInput($event, 'partyZipCode')" />
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div v-show="tabName !== 'isf'" class="section">
        <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="44" @click="cargoDocUsageSelectedDialog.visible=true">{{ getItemTitle('Add') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.RemoveContainerInformation')" no="45" @click="removeContainerUsageClickHandler">{{ getItemTitle('Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            config-module="130701"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="containerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="warningCount"
        :disabled="readonly"
        style="height: 198px;"
        no="46"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="47" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="48"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptInfoDialog.visible"
      :title="receiptInfoDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptInfoDialog.gridOptions"
        :column-defs="receiptInfoDialog.columnDefs"
        :row-data="receiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{receiptInfoDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 选择装箱信息弹窗 -->
    <cargo-doc-usage-selected-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.AMS"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- AMS日志弹窗 -->
    <ams-log-view-title-dialog
      :visible.sync="amsLogViewTitleDialog.visible"
      :row-data="amsLogViewTitleDialog.rowData"
    />
    <!-- 单号抄录弹窗 -->
    <afr-address-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!--选择目的地-->
    <select-sub-loc-dialog
      :visible.sync="selectSubLocDialog.visible"
      :type="selectSubLocDialog.type"
      @select="selectSubLocCallBack"
      @close="()=>selectSubLocDialog.visible=false"
    />
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!--查看回执-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptDialog.visible"
      :title="receiptDialog.title"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptDialog.gridOptions"
        :column-defs="receiptColumnDefs"
        :row-data="receiptDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{receiptDialog.gridApi=params.api}"
      />
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoDocUsageSelectedDialog from '@/components/Cargo/Job/cargoDocUsageSelectedDialog'
import amsLogViewTitleDialog from '@/components/Cargo/Job/amsLogViewTitleDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import selectSubLocDialog from '@/views/cargo/v0/SeaExport/components/booking/selectSubLocDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import tabISF10 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabISF10'
import tabISF05 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabISF05'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import AddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/addressFormatForm'
import AfrAddressDialog from '@/components/Cargo/Job/afrAddressDialog'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey } from '@/utils/basicDataCache'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as isfPassengerApi from '@/api/seaExport/isfPassenger'

export default {
  name: 'AmsInfo',
  components: {
    AfrAddressDialog,
    AddressFormatForm,
    CargoRichTextarea, tabISF10, tabISF05, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoPackingSelect, cargoDocUsageSelectedDialog, selectSubLocDialog,
    amsLogViewTitleDialog, searchBillNoDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    showISF: { type: Boolean, default: false },
    ams2: { type: Object, default: () => {} },
    container: { type: Object, default: () => {} },
    form: { type: Object, default: () => {} },
    pm: { type: Object, default: () => {} },
    partyNameList: { type: Array, default: () => [] },
    localData: { type: Object, default: () => {} },
    showCodeSearch: { type: Boolean, default: false },
    showSecondNotifyParty: { type: Boolean, default: false },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isJs: { type: Boolean, default: false }
  },
  data() {
    return {
      SystemConstants,
      URL,
      secondGenerationCheck: false,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      moment,
      TYPE_NAMES,
      CargoDocConsts,
      CargoDocUtil,
      maxChars: 34,
      isUppercase: false,
      command1: 'Copy Last Time',
      amsCheck: true,
      txtCarrierScAc: '',
      filingType: 'I',
      consignmentTypes: ['FCL', 'LCL'],
      customerTypes: ['BCO', 'NVO'],
      gdAMS2: {
        rowData: []
      },
      selectSubLocDialog: {
        visible: false,
        type: 1
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      receiptInfoDialog: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.receiptDate'),
            colId: 'receiptDate',
            field: 'receiptDate',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.receiptCode'),
            colId: 'receiptCode',
            field: 'receiptCode',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Content'),
            colId: 'receiptContent',
            field: 'receiptContent',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      receiptDialog: {
        visible: false,
        title: 'Receipt',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      amsLogViewTitleDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      curAms: null,
      activeTabName: 'tabBookingISF10',
      sendEFTypes: [],
      sendAMSTypes: [],
      cargoDocs: [],
      isTradetech: false,
      isEFreight: false,
      deleteAMS: false,
      isChineseLanguage: false,
      selfDeclarationList: [], // 存储自申报名称列表
      partyNames: [],
      lineType: '', // 区分是Name 还是 Address
      saveAs: '1', // 1为发送， 2为保存
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    carrierScAc() {
      if (this.tabName === 'aci' || this.tabName === 'eManifest') {
        return this.localData.eManifestCarrierScAc
      }
      return this.localData.txtCarrierScAc
    },
    language() {
      return this.$store.getters.language
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    config() {
      return this.context.config
    },
    job() {
      return this.pm.job
    },
    excelImportDisabled() {
      return this.job.jobState !== 0
    },
    user() {
      return this.context.user || {}
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.tabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.tabName)
    },
    warningCount() {
      if (this.isEFreight) return this.lineType === 'Name' ? 70 : 50
      return this.tabName === 'eManifest' ? 50 : 35
    },
    containerColumnDefs() {
      const uuid = [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }
      ]
      const containerSize = [
        {
          headerName: this.getItemTitle('Container Size'),
          headerTooltip: this.$t('SeaExport.BoxModel'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160,
          cellRenderer: (params) => {
            return params.value + '\''
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      const containerCode = [
        {
          headerName: this.getItemTitle('Container Code'),
          colId: 'eqCode',
          field: 'eqCode',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.JS_AFR_CONTAINER_SIZE,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.JS_AFR_CONTAINER_SIZE, params.value)
          }
        }
      ]
      const containerType = [
        {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqType',
          field: 'eqType',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      const containerNo = [
        {
          headerName: this.getItemTitle('Container No'),
          headerTooltip: this.$t('SeaExport.ContainerNumber'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        }
      ]
      const quantity = [
        {
          headerName: this.isChineseLanguage ? '件数' : 'Quantity',
          headerTooltip: this.$t('SeaExport.itemCount'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }
      ]
      const unitType = [
        {
          headerName: this.getItemTitle('Unit Type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          colId: 'packing',
          field: 'packing',
          width: 160,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', this.form.packing, 'name')
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      const jsUnitType = [
        {
          headerName: this.getItemTitle('Unit Type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          colId: 'packing',
          field: 'packing',
          width: 160,
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code',
              customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
              showCustomLabelInOption: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        }
      ]
      const grossWeight = [
        {
          headerName: this.getItemTitle('Gross Weight'),
          headerTooltip: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                let precision = 3
                if (this.jsSendHide) {
                  precision = 0
                }
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, precision))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }
      ]
      const volume = [
        {
          headerName: this.getItemTitle('Volume'),
          headerTooltip: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                let precision = 3
                if (this.jsSendHide) {
                  precision = 0
                }
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, precision))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }
      ]
      const goods = [
        {
          headerName: this.getItemTitle('Goods'),
          hide: true,
          headerTooltip: this.$t('SeaExport.CommodityName'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Goods')
          }
        }
      ]
      const marks = [
        {
          headerName: this.getItemTitle('Marks'),
          hide: true,
          headerTooltip: this.$t('SeaExport.ShippingMark'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Marks')
          }
        }
      ]
      const sealNo = [
        {
          headerName: this.getItemTitle('Seal No'),
          headerTooltip: this.$t('SeaExport.SealNumber'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      if (this.jsSendHide && this.isAms) {
        return [...uuid, ...containerSize, ...containerType, ...containerCode, ...goods, ...containerNo, ...quantity, ...jsUnitType, ...grossWeight, ...sealNo, ...marks, ...volume]
      }
      if (this.jsSendHide && this.isAci) {
        return [...uuid, ...marks, ...quantity, ...containerNo, ...jsUnitType, ...grossWeight, ...volume]
      }
      return [...uuid, ...containerSize, ...containerType, ...goods, ...containerNo, ...quantity, ...unitType, ...grossWeight, ...volume, ...marks, ...sealNo]
    },
    containerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    ams2ColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          headerTooltip: this.amsTitleCn,
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260
        }, {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'ams' && !this.isJs), suppressColumnsToolPanel: !(this.tabName === 'ams' && !this.isJs),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'AMSSTATUS',
          field: 'AMSSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        }, {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'isf'),
          suppressColumnsToolPanel: !(this.tabName === 'isf'),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'ISFSTATUS',
          field: 'ISFSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (this.activeTabName === 'tabBookingISF05') {
              return this.pm.setStatus(params.data.ISF5STATUS)
            }
            return this.pm.setStatus(params.data.ISF10STATUS)
          },
          tooltipValueGetter: (params) => {
            if (this.activeTabName === 'tabBookingISF05') {
              return this.pm.setStatus(params.data.ISF5STATUS, true)
            }
            return this.pm.setStatus(params.data.ISF10STATUS, true)
          }
        }, {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'aci' && !this.isJs), suppressColumnsToolPanel: !(this.tabName === 'aci' && !this.isJs),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'ACISTATUS',
          field: 'ACISTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        }, {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'eManifest'), suppressColumnsToolPanel: !(this.tabName === 'eManifest'),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'EFSTATUS',
          field: 'EFSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        },
        {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'ams' && this.isJs), suppressColumnsToolPanel: !(this.tabName === 'ams' && this.isJs),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'jsAmsStatus',
          field: 'jsAmsStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setJsStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setJsStatus(params.value, true)
          }
        },
        {
          headerName: this.getItemTitle('Send State'),
          hide: !(this.tabName === 'aci' && this.isJs), suppressColumnsToolPanel: !(this.tabName === 'aci' && this.isJs),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'jsAciStatus',
          field: 'jsAciStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setJsStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setJsStatus(params.value, true)
          }
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'ams' && !(this.isTradetech && this.deleteAMS) && !this.isJs), suppressColumnsToolPanel: !(this.tabName === 'ams' && !(this.isTradetech && this.deleteAMS) && !this.isJs),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'amsReceiptStatus',
          field: 'amsReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return 'receive'
          },
          tooltipValueGetter: (params) => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return '已接收'
          }
        }, {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'ams' && this.isTradetech && this.deleteAMS), suppressColumnsToolPanel: !(this.tabName === 'ams' && this.isTradetech && this.deleteAMS),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'tradetechAmsReceiptStatus',
          field: 'tradetechAmsReceiptStatus',
          flex: 1,
          width: 260
        }, {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'isf'), suppressColumnsToolPanel: !(this.tabName === 'isf'),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'isfReceiptStatus',
          field: 'isfReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return 'receive'
          },
          tooltipValueGetter: (params) => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return '已接收'
          }
        }, {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'aci' && !this.isJs), suppressColumnsToolPanel: !(this.tabName === 'aci' && !this.isJs),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'aciReceiptStatus',
          field: 'aciReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return 'receive'
          },
          tooltipValueGetter: (params) => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return '已接收'
          }
        }, {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'eManifest'), suppressColumnsToolPanel: !(this.tabName === 'eManifest'),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'eManifestReceiptStatus',
          field: 'eManifestReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return 'receive'
          },
          tooltipValueGetter: (params) => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            }
            return '已接收'
          }
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'ams' && this.isJs), suppressColumnsToolPanel: !(this.tabName === 'ams' && this.isJs),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'jsAmsReceiptStatus',
          field: 'jsAmsReceiptStatus',
          flex: 1,
          width: 260
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !(this.tabName === 'aci' && this.isJs), suppressColumnsToolPanel: !(this.tabName === 'aci' && this.isJs),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'jsAciReceiptStatus',
          field: 'jsAciReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setJsAciReceiptStatus(params.value)
          }
        },
        {
          headerName: this.getItemTitle('Cancellation status'),
          hide: !(this.tabName === 'ams' && this.isTradetech && this.deleteAMS),
          suppressColumnsToolPanel: !(this.tabName === 'ams' && this.isTradetech && this.deleteAMS),
          headerTooltip: this.$t('SeaExport.CancellationStatus'),
          colId: 'AMSDELETE',
          field: 'AMSDELETE',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setDelStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setDelStatus(params.value)
          }
        }
      ]
    },
    // 是否是危险品
    isDangerousCargo() {
      return this.form.goodsType === 1
    },
    jsSendHide() {
      return this.isJs && this.saveAs === '1'
    },

    isAms() {
      return this.tabName === 'ams'
    },
    isAci() {
      return this.tabName === 'aci'
    },
    receiptColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          field: 'ams',
          width: 200
        },
        {
          headerName: 'Receipt Status',
          field: 'receiptCode',
          width: 200,
          cellRenderer: params => {
            if (this.isAci) {
              return this.pm.setJsAciReceiptStatus(params.value)
            }
            return params.value
          }
        },
        {
          headerName: 'Description',
          field: 'remark',
          width: 375
        },
        {
          headerName: 'Time',
          field: 'receiptDate',
          width: 200
        }
      ]
    }
  },
  watch: {
    activeTabName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs[this.activeTabName].onShow()
        this.pm.changeIsfActiveTab(this.activeTabName)
        if (this.ams2 && this.ams2.gridOptions) {
          this.ams2.gridOptions.api.clearFocusedCell()
          this.ams2.gridOptions.api.refreshCells({ force: true })
        }
      }
    },
    tabName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initPartyNames()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.visible = true
    this.isTradetech = this.config.get('AMSInterfaceName') === 'tradetech'
    this.isEFreight = this.config.get('AMSInterfaceName') === 'eFreight'
    this.deleteAMS = parseInt(this.config.get('DeleteAMS')) === 1
    this.isChineseLanguage = Number(this.config.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.initPartyNames()
  },
  methods: {
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    packageInfoChanged(params) {
      if (this.form.docType === CargoDocConsts.AMS) {
        let sum = 0
        for (const item of this.container.rowData) {
          if (item.deleted) {
            continue
          }
          sum += Number(item[params.field])
        }
        this.form[params.field] = sum
      }
    },
    /**
     * 移除装箱信息
     */
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        if (row.uuid) {
          row.deleted = true
        } else {
          const index = this.container.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.container.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.container.rowData
      this.container.rowData = []
      this.$nextTick(() => {
        this.container.rowData = tempRowData
        if (this.form.docType === CargoDocConsts.AMS) {
          this.pm.refreshEdiGrid()
        }
      })
    },
    commandHandle(command) {
      switch (command) {
        case 'Code Searching':
          this.billAddressDialog.visible = true
          break
        case 'Copy Last Time':
          this.pm.onCopy1()
          break
        case 'Copy By File NO':
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'AMS',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    // 组装打印参数
    getPrintData() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
      }
      const params = {}
      params.BLNbr2 = this.form.hblNbr2
      params.cargoDocUuid = this.form.uuid
      params.DOC_UUID = this.form.uuid
      params.category = 'AMS'
      params.ctx = new SeaCargoDoc(this.form)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(view.cargoDoc, 'AMS', params, view)
    },
    hblNbr2Change() {
      const { gridApi } = this.ams2
      gridApi.refreshCells()
      this.$nextTick(() => {
        if (this.curAms) {
          const { rowsToDisplay } = gridApi.getModel()
          const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curAms.hblNbr2)
          selectedNode.setSelected(true)
        }
      })
    },
    amsRadioChangeHandler() {
      this.pm.AMSTypeChangeHandler(this.form.AMSType)
      this.AMSTypeChange(this.form.AMSType)
    },
    getValueFromChild(obj) {
      this.form[obj.key] = obj.value
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        maxChar: 45, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    // 第三方数据
    portChange2(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.name
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showSenderAndReceiverDialog(type, count, isAmsAndManifest = false) {
      let value = ''
      if (this.isEFreight) {
        value = this.eFreightMergeSenderAndReceiverLine(type, count)
      } else {
        value = !isAmsAndManifest ? this.mergeSenderAndReceiverLine(type, count) : this.mergeSenderAndReceiverLineForAmsAndManifest(type, count)
      }
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          break
        case 'notify':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier')
          break
        case 'alsonotifyLine':
          this.advanceTextDialog.title = this.$t('SeaExport.SecondNotifier')
          break
        case 'shipperLineName':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper') + '-NAME'
          break
        case 'shipperLineAddress':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper') + '-ADDRESS'
          break
        case 'consigneeLineName':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee') + '-NAME'
          break
        case 'consigneeLineAddress':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee') + '-ADDRESS'
          break
        case 'notifyLineName':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier') + '-NAME'
          break
        case 'notifyLineAddress':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier') + '-ADDRESS'
          break
      }
      this.advanceTextDialog.value = value
      if (this.isEFreight) {
        this.advanceTextDialog.successCallback = () => this.eFreightSplitSenderAndReceiverLine(type, count, this.advanceTextDialog.value)
      } else {
        this.advanceTextDialog.successCallback = () => !isAmsAndManifest ? this.splitSenderAndReceiverLine(type, count, this.advanceTextDialog.value) : this.splitSenderAndReceiverLineForAmsAndManifest(type, count, this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = true
    },
    mergeSenderAndReceiverLine(type, count) {
      const addressForm = this.form.afrAddress[0]
      let result = ''
      for (let i = 1; i < count; ++i) {
        result += addressForm[`${type}Line${i}`] || ''
        result += '\n'
      }
      result += (addressForm[`${type}Line${count}`] || '')
      return result.trimEnd()
    },
    splitSenderAndReceiverLine(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      let fromIndex = 0
      let i = 1
      for (; i < count; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${i}`] = ''
          continue
        }
        addressForm[`${type}Line${i}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${i}`] = val.substring(fromIndex)
    },
    // eFreight 通道使用
    eFreightMergeSenderAndReceiverLine(type, count) {
      const splitArray = type.split('Line')
      this.lineType = ''
      if (splitArray && splitArray.length > 0) {
        type = splitArray[0].trim()
        this.lineType = splitArray[1].trim()
      }
      const addressForm = this.form.afrAddress[0]
      let result = ''
      let i = 1
      if (this.lineType === 'Address') {
        i = 2
      }
      for (; i <= count; ++i) {
        let no = i
        if (i !== 1) {
          no = (i + 1)
        }
        result += addressForm[`${type}Line${no}`] || ''
        if (i !== count) {
          result += '\n'
        }
      }
      return result
    },
    eFreightSplitSenderAndReceiverLine(type, count, val) {
      const splitArray = type.split('Line')
      this.lineType = ''
      if (splitArray && splitArray.length > 0) {
        type = splitArray[0].trim()
        this.lineType = splitArray[1].trim()
      }
      const addressForm = this.form.afrAddress[0]
      let fromIndex = 0
      let i = 1
      let no = 1
      if (this.lineType === 'Address') {
        i = 2
      }
      for (; i <= count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        if (i !== count || i === 1) {
          addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        } else {
          addressForm[`${type}Line${no}`] = val.substring(fromIndex)
        }
        fromIndex = index + 1
      }
    },
    // AMS 和 EManifest 页签使用
    mergeSenderAndReceiverLineForAmsAndManifest(type, count) {
      const addressForm = this.form.afrAddress[0]
      let result = ''
      for (let i = 1; i < count; ++i) {
        let no = i
        if (i !== 1) {
          no = (i + 1)
        }
        result += addressForm[`${type}Line${no}`] || ''
        result += '\n'
      }
      result += (addressForm[`${type}Line${count + 1}`] || '')
      return result.trimEnd()
    },
    // AMS 和 EManifest 页签使用
    splitSenderAndReceiverLineForAmsAndManifest(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      let fromIndex = 0
      let i = 1
      let no = 1
      for (; i < count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${no + 1}`] = val.substring(fromIndex)
    },
    isDifferent(field) {
      return this.localData.importDifferentField && this.localData.importDifferentField.hasOwnProperty(field) ? 'warning' : ''
    },
    changeUnitType(p) {
      this.form.packing = p.value
      this.container.gridOptions.api.clearFocusedCell()
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    setCellColor(data, field) {
      const importDifferentField = this.localData.importDifferentField
      if (!importDifferentField ||
        !importDifferentField.container ||
        !importDifferentField.container[data.containerNo]) {
        return {}
      }
      if (importDifferentField.container[data.containerNo].hasOwnProperty(field)) {
        return { 'color': 'red' }
      }
      return {}
    },
    selectSubLoc(type) {
      this.selectSubLocDialog.type = type
      this.selectSubLocDialog.visible = true
    },
    selectSubLocCallBack(row, type) {
      if (type === 1) {
        if (row) {
          this.form.dishSubLoc = row.subLocationCode
          this.localData.dishSubLocStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.dishSubLoc = ''
          this.localData.dishSubLocStr = ''
        }
      } else if (type === 2) {
        if (row) {
          this.form.subLocationCode = row.subLocationCode
          this.localData.subLocationCodeStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.subLocationCode = ''
          this.localData.subLocationCodeStr = ''
        }
      }
      this.selectSubLocDialog.visible = false
    },
    changeDispatchingPlace(p) {
      this.form.dispatchingPlace = p.code
    },
    changeVoyage() {
      this.form.voyageFlight = CargoDocUtil.replaceVoyage(this.form.voyageFlight, true)
    },
    queryReceipt(data) {
      this.receiptDialog.visible = true
      this.receiptDialog.rowData = data || []
    },
    openCheckTip(data) {
      this.checkDialog.visible = true
      // 去重
      const uniqueMap = new Map()
      if (data) {
        data.forEach(item => {
          const key = item.field + '|' + item.errorDescription
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, item)
          }
        })
      }
      this.checkDialog.rowData = Array.from(uniqueMap.values())
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    getAciImportInfo(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.aciLabelFunc(targetCode)
      }
      return targetCode
    },
    handleColoadInSelfFilingIndicatorChange(value) {
      if (!value) {
        this.form.partyName = ''
        this.form.partyCode = ''
        this.form.partyAddressLine = ''
        this.form.partyCountryCode = ''
        this.form.partyCity = ''
        this.form.partyProvince = ''
        this.form.partyZipCode = ''
      }
    },
    handleNameSelect(value) {
      let partyName = value.partyName
      if (!partyName) {
        this.form.partyName = ''
        this.form.partyCode = ''
        this.form.partyAddressLine = ''
        this.form.partyCountryCode = ''
        this.form.partyCity = ''
        this.form.partyProvince = ''
        this.form.partyZipCode = ''
        return
      }
      partyName = partyName.replace(/[^A-Za-z0-9]/g, '')
      partyName = partyName.slice(0, 70)
      if (!partyName) {
        return
      }
      const passenger = this.partyNames?.find(p => p.partyName === partyName)
      if (passenger) {
        this.form.partyCode = passenger.partyCode
        this.form.partyName = passenger.partyName
        this.form.partyAddressLine = passenger.addressLine
        this.form.partyCountryCode = passenger.countryCode
        this.form.partyCity = passenger.city
        this.form.partyProvince = passenger.subDivisionCode
        this.form.partyZipCode = passenger.postalCode
      } else {
        // 如果是新输入的值
        this.form.partyName = partyName
        this.form.partyCode = ''
        this.form.partyAddressLine = ''
        this.form.partyCountryCode = ''
        this.form.partyCity = ''
        this.form.partyProvince = ''
        this.form.partyZipCode = ''
        const isfPassenger = {}
        isfPassenger.partyName = partyName
        isfPassenger.partyCode = ''
        isfPassenger.addressLine = ''
        isfPassenger.countryCode = ''
        isfPassenger.city = ''
        isfPassenger.subDivisionCode = ''
        isfPassenger.postalCode = ''
        isfPassenger.partyType = 'CSFI'
        isfPassenger.isfType = 1
        isfPassenger.customerId = this.job.customerId
        isfPassenger.opOffice = this.job.opOffice
        isfPassenger.opType = 'add'
        this.form.isfPassenger.push(isfPassenger)
        this.selfDeclarationList.push({
          partyName: partyName,
          value: partyName,
          label: partyName
        })
        // 强制更新组件的显示值
        this.$nextTick(() => {
          if (this.$refs.partyName) {
            this.$refs.partyName.value = partyName
            // 触发组件的 input 事件以确保双向绑定更新
            this.$refs.partyName.$emit('input', partyName)
          }
        })
      }
    },
    filterInput(value, fieldName) {
      // 动态过滤指定字段的输入内容
      if (this.form[fieldName]) {
        this.form[fieldName] = value.replace(/[^A-Za-z0-9]/g, '')
      }
    },
    filterAlphabetOnly(value, fieldName) {
      if (this.form[fieldName]) {
        this.form[fieldName] = value.replace(/[^a-zA-Z]/g, '')
      }
    },
    initPartyNames() {
      if (this.isEdit && this.tabName === 'eManifest' && this.job.customerId) {
        isfPassengerApi.getISFPassengersList({ customerId: this.job.customerId }).then(resp => {
          if (resp.data) {
            for (const isf of resp.data) {
              const index = this.partyNames.findIndex(p => p.partyName === isf.partyName)
              if (index === -1) {
                this.partyNames.push(isf)
              }
            }
            if (this.partyNames) {
              this.selfDeclarationList = this.partyNames
                .filter(passenger => passenger.partyType === 'CSFI' && passenger.isfType === 1)
                .map(passenger => ({
                  partyName: passenger.partyName,
                  value: passenger.partyName,
                  label: passenger.partyName
                }))
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .ams-info{
    .warning .el-input__inner{
      color: red !important;
    }
    .warning{
      color: red !important;
    }
    .el-radio__label{
      font-size: 12px;
      font-weight: normal;
      color: #333333 !important;
    }
    .el-checkbox__label{
      font-weight: normal;
      color: #333333 !important;
    }
    .self-declaration-fields {
      .center-label{
        margin-left: 5px;
        margin-right: 5px;
        width: 110px;
      }

    }
  }
</style>
